export default {
	namespaced: true,
	state: {
		loans: [],
		deposits: [],
		slAccounts: [],
	},

	mutations:{
		setLoans(state, payload) {
			state.loans=payload
		},

		setDeposits(state, payload) {
			state.deposits=payload
		},

		setSLAccounts(state, payload) {
			state.slAccounts=payload
		},
	},
	getters:{
		getLoans (state) {
			return state.loans
		},


		getDeposits(state) {
			return state.deposits
		},


		getSLAccounts(state) {
			return state.slAccounts
		},
	},
	actions: {
		
	},

}